<template>
  <div class="user_home">
    <div class="ladingpage"
         v-show="ladingFlag">
      <!-- <loding1 class="loding" /> -->
    </div>
    <div class="user_info">
      <div class="user_infoIitem user_icon"
           @click="getConsole"
           :class="isZm?'zm':''"></div>
      <div class="user_infoIitem user_account">
        <p><i class="user_label">{{$t('home.accountTitle')}}:</i> <span class="user_text">{{name}}</span></p>
        <p><i class="user_label">OPENID:</i> <span class="user_text">{{uid}}</span></p>
      </div>
      <!-- <div class="change_user_btn fr"
           v-show="!isClient"
           @click="changeUser">{{$t('home.checkAccountBtn')}}</div> -->
    </div>
    <ul class="btn_list">
      <!-- 设置账号名 -->
      <!-- <router-link :to="{name:'AccountVerify', params: {id:1}}"> -->
      <li class="btn_item"
          @click="gotoAccountVerify(1,2)">
        {{$t('home.getNameTitle')}}
        <span class="passIconfont_item"></span>
      </li>
      <!-- </router-link> -->
      <!-- //关联账号 -->
      <router-link v-if="AssociatedFlag"
                   :to="{name:'AssociatedAccount', params: {id:2}}">
        <li class="btn_item">
          {{$t('home.linkAccountTitle')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <router-link to="/logoffTips">
        <li class="btn_item">
          <!-- 删除账号 -->
          {{$t('home.logOffTitle')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <li class="btn_item"
          @click="gotoAccountVerify(3,1)">
        <!-- 设置修改密码 -->
        {{$t('home.changePsw')}}
        <span class="passIconfont_item"></span>
      </li>
      <li class="btn_item"
          v-show="show_login_device==1"
          @click="gotoAccountVerify(4,2)">
        {{$t('title.title16')}}
        <span class="passIconfont_item"></span>
      </li>
      <li class="btn_item"
          @click="gotoAccountVerify(5,1)"
          v-if="!isZm">
        {{$t('home.changeEmailBtn')}}
        <span class="passIconfont_item"></span>
      </li>
      <router-link to="/Privacy">
        <li class="btn_item">
          {{$t('title.title21')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <router-link to="/user">
        <li class="btn_item">
          {{$t('title.title22')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <router-link :to="isZm?'/zmFAQ':'/FAQ'">
        <li class="btn_item">
          {{$t('home.FAQTitle')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <router-link to="/qiyukf"
                   v-show="kfFlag">
        <li class="btn_item">
          <!-- 联系客服 海外版-->
          {{$t('home.kefu')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
      <router-link to="/queryCenter"
                   v-if="queryFlag">
        <li class="btn_item">
          <!-- 自助查询 -->
          {{$t('home.query')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>

      <router-link to="/preamble"
                   v-if="isJp">
        <li class="btn_item">
          {{$t('home.yinjicode')}}
          <span class="passIconfont_item"></span>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mailMosk, nameMosk } from '@/utils/utils'
import loding1 from '../components/loading.vue'
import { getSessionStorage, setSessionStorage, getToken } from '@/utils/stage'
import { appPostMessage } from '@/utils/communication'
import VConsole from 'vconsole/dist/vconsole.min.js'
export default {
  components: {
    loding1,
  },
  data() {
    return {
      clickNum: 1,
      AssociatedFlag: false,
      accountTitle: '',
      checkAccountBtn: '',
      name: '',
      uid: '',
      loginDeviceFlag: false,
      ladingFlag: true,
      changepsw: '',
      phonetext: this.$t('home.binded'),
      pswtext: this.$t('home.clickPswTitle'),
      idtext: '已认证',
      idFlag: false,
      phoneFlag: false,
      emailFlag: false,
      emailtext: this.$t('home.binded'),
      id: '',
      email: '',
      phone: '',
      psw: '******',
      lang: '',
      configData: '',
      isClient: 0,
      changePhoneFlag: false,
      changeEmailFlag: false,
      accountStorage: '',
      show_login_device: '',
      queryFlag: false,
      kfFlag: true,
      isZm: false,
      isJp: false,
      consoleNum: 1,
    }
  },
  mounted() {},
  created() {
    this.init()
  },
  methods: {
    clickConsole() {
      ++this.clickNum
      console.log(this.clickNum)
      if (this.clickNum > 9) {
        let vConsole = new VConsole()
      }
    },
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      this.accountStorage = JSON.parse(getSessionStorage('accountStorage'))
      this.show_login_device = JSON.parse(
        getSessionStorage('accountStorage')
      ).web_config.show_login_device
      this.getAccount(this.accountStorage)
    },
    getAccount(res) {
      if (res) {
        const user_entity = res
        setSessionStorage('lang', res.lang)
        console.log(res, 11)
        if (res.app_id == 'c8a39614babd76c97a2b26844a72e886') {
          this.kfFlag = false
        }
        if (res.lang == 'en-us') {
          this.kfFlag = false
        }
        if (res.web_config.zm == 1) {
          this.kfFlag = false
          this.isZm = true
        }
        if (res.web_config.jp == 1) {
          this.isJp = true
        }
        if (res.web_config.service_url && res.uid && res.role_name) {
          this.queryFlag = true
        }
        if (res.login_ways.length > 0) {
          this.loginDeviceFlag = true
        }
        this.isClient = user_entity.isClient ? user_entity.isClient : 0
        if (res.has_set_username) {
          this.name = nameMosk(user_entity.username)
        } else {
          this.name = mailMosk(user_entity.email)
        }
        if (res.login_ways.length > 0) {
          this.AssociatedFlag = true
        }
        this.emailtext = this.$t('home.binded')
        this.pswtext = this.$t('home.clickPswTitle')

        this.uid = user_entity.open_id
        this.email = user_entity.email ? mailMosk(user_entity.email) : ''
        if (user_entity.email) {
          this.email = this.email
        } else {
          this.changeEmailFlag = true
          this.emailtext = this.$t('home.goBind')
        }
        const usermsg = {
          phone: this.phone,
          email: this.email,
          id: this.id,
        }
        setSessionStorage('usermsg', JSON.stringify(usermsg))
        this.ladingFlag = false
      }
    },
    setBanner(data) {
      setSessionStorage('banner_title', JSON.stringify(data))
    },
    gotoLogoff() {
      setTimeout(() => {
        this.$router.push('/logoffTips')
      }, 300)
    },
    changeUser() {
      const msg = { code: 4, data: '' }
      appPostMessage(msg)
    },
    gotoAccountVerify(id, type) {
      let csrf_token_info_id = ''
      if (getToken('csrf_token_info')) {
        const csrf_token_info = JSON.parse(getToken('csrf_token_info'))
        csrf_token_info_id = csrf_token_info.id
      }
      //type=1 ；一次性 type=2 多次
      if (csrf_token_info_id == this.accountStorage.open_id && type == 2) {
        let routerUrl = ''
        switch (id) {
          case 1:
            routerUrl = 'SetName'
            break
          case 2:
            routerUrl = 'AssociatedAccount'
            break
          case 3:
            routerUrl = 'ChangePassword'
            break
          case 4:
            routerUrl = 'Loginrecord'
            break
          default:
        }
        this.$router.push({ name: routerUrl, params: { id: id } })
      } else {
        this.$router.push({ name: 'AccountVerify', query: { id: id } })
      }
    },
    getConsole() {
      this.consoleNum++
      if (this.consoleNum > 9) {
        new this.$vconsole()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.user_home {
  .ladingpage {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.99);
    z-index: 999;
    .loding {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }
  .user_info {
    width: 100%;
    height: 188/75rem;
    padding-top: 45/75rem;
    padding-left: 30/75rem;
    box-sizing: border-box;
    border-bottom: 9/75rem solid #f8f8f8;
    .user_infoIitem {
      display: inline-block;
      float: left;
    }
    .user_icon {
      width: 110/75rem;
      height: 110/75rem;
      background: url('../../assets/images/favicon.png') no-repeat;
      background-size: contain;
      border-radius: 55/75rem;
    }
    .zm {
      width: 110/75rem;
      height: 110/75rem;
      background: url('../../assets/images/zm.png') no-repeat;
      background-size: contain;
      border-radius: 55/75rem;
    }
  }
  .user_account {
    margin-top: -10/75rem;
    text-align: center;
    text-align: left;
    .user_label {
      margin-left: 30/75rem;
      margin-right: 5/75rem;
      display: inline-block;
      //   width: 100/75rem;
      height: 35/75rem;
      font-size: 26/75rem;
      font-family: 'Microsoft YaHei';
      line-height: 75/75rem;
      color: #000000;
      font-weight: 400;
      text-align: right;
    }
    .user_text {
      font-size: 26/75rem;
      font-family: 'Microsoft YaHei';
      line-height: 38/75rem;
      color: #575757;
    }
  }
  .change_user_btn {
    float: right;
    min-width: 146/75rem;
    padding: 0 10/75rem;
    text-align: center;
    height: 50/75rem;
    border: 1/75rem solid #ff7391;
    opacity: 1;
    border-radius: 30/75rem;
    line-height: 50/75rem;
    font-size: 26/75rem;
    font-family: 'Microsoft YaHei';
    color: #ff7391;
    margin-right: 35/75rem;
    margin-top: 25/75rem;
  }
  .change_userInfo_box {
    padding: 0 28/75rem;
    .userInfo_list {
      .changeiser_item {
        height: 95/75rem;
        line-height: 95/75rem;
        border-bottom: 1/75rem solid #ececec;
        .changeuser_label {
          float: left;
          display: inline-block;
          width: 200/75rem;
          font-size: 26/75rem;
          font-family: 'Microsoft YaHei';
          color: #000000;
          font-weight: 700;
        }
        .user_info_text {
          text-align: left;
          display: inline-block;
          width: 45%;
          float: left;
          font-size: 26/75rem;
          color: #8d8d8d;
        }
        .btn_text {
          display: inline-block;
          float: right;
          text-align: right;
          font-size: 22/75rem;
          color: #8d8d8d;
          width: 140/75rem;
          position: relative;
          padding-right: 15/75rem;
          .passIconfont_item {
            position: absolute;
            width: 10/75rem;
            height: 20/75rem;
            background: url('../../../src/assets/images/back.png') no-repeat;
            background-size: contain;
            transform: rotate(180deg);
            -ms-transform: rotate(180deg); /* IE 9 */
            -moz-transform: rotate(180deg); /* Firefox */
            -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
            -o-transform: rotate(180deg); /* Opera */
            top: 35/75rem;
            right: -5/75rem;
          }
        }
      }
    }
  }
  .btn_list {
    padding: 0 15/75rem;
    margin-top: 60/75rem;
    .btn_item {
      width: 326/75rem;
      height: 72/75rem;
      background: rgba(255, 255, 255, 0.39);
      border: 1/75rem solid #707070;
      opacity: 1;
      border-radius: 20/75rem;
      padding: 0 23/75rem;
      box-sizing: border-box;
      float: left;
      margin: 15/75rem;
      font-size: 21/75rem;
      font-family: 'Microsoft YaHei';
      line-height: 72/75rem;
      color: #575757;
      text-align: left;
      position: relative;
      .passIconfont_item {
        display: block;
        width: 10/75rem;
        height: 20/75rem;
        background: url('../../../src/assets/images/back.png') no-repeat;
        background-size: contain;
        transform: rotate(180deg);
        -ms-transform: rotate(180deg); /* IE 9 */
        -moz-transform: rotate(180deg); /* Firefox */
        -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
        -o-transform: rotate(180deg); /* Opera */
        top: 20/75rem;
        right: 23/75rem;
        position: absolute;
      }
    }
  }
}
</style>
